import WordWrapEllipse from 'components/Dam/WordWrapEllipse';
import { Spinner } from 'reactstrap';
const { ButtonC } = require('Common/Buttons');
const { Modal, ModalBody, ModalFooter } = require('reactstrap');

export const Deletemodel = ({
  deletemodal,
  toggledelete,
  handleDelete,
  loading = false,
  Header = 'Delete',
  Content = 'Are you sure you want to delete?',
  SubContent = '',
  isCloseButton = false,
}) => {
  return (
    <Modal size="lg" isOpen={deletemodal} toggle={toggledelete} className="Size-adjust">
      <div className="modal-header border_bottom_none delete_modal_Padding" onClick={toggledelete}>
        <h5 className="modal-title">
          <WordWrapEllipse Text={Header} />{' '}
        </h5>
        <button type="button" className="close" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <ModalBody className="padding_top_0_imp">
        <div>
          <div
            className="crm_task_history_header_desing_2 crm_font_w_400_imp crm_fs_16p_imp"
            style={{
              lineHeight: '19.36px',
            }}
          >
            {Content}
          </div>
          <div
            className="crm_task_history_header_desing_2 crm_font_w_600 crm_fs_16p_imp"
            style={{
              lineHeight: '19.36px',
            }}
          >
            {SubContent && <span>Note: {SubContent}</span>}
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="border_top_none  padding_right_32 padding_bottom_24">
        {isCloseButton && (
          <ButtonC size="lg" color="Primary" text="Close" click={toggledelete}>
            {' '}
          </ButtonC>
        )}
        {!isCloseButton && (
          <ButtonC size="lg" color="Primary" text="Yes" disabled={loading} click={handleDelete}>
            {' '}
            {loading && <Spinner color="light" className="mx-1" size="sm" />}
          </ButtonC>
        )}
        {!isCloseButton && <ButtonC size="lg" color="Secondary" text="No" click={toggledelete} />}
      </ModalFooter>
    </Modal>
  );
};
